/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RouteRebookingKindEnum =
  (typeof RouteRebookingKindEnum)[keyof typeof RouteRebookingKindEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RouteRebookingKindEnum = {
  FillShortDay: 0,
  ShortenWait: 1,
  FitWithinDayCap: 2,
} as const;
